var _path, _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 39 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h38v38H.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19,
    r: 17.417,
    fill: "#8C919F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#youtube_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M27.159 12.418a2.48 2.48 0 0 1 1.733 1.768h-.002c.41 1.56.41 4.814.41 4.814s0 3.255-.41 4.814a2.48 2.48 0 0 1-1.733 1.768C25.63 26 19.5 26 19.5 26s-6.13 0-7.657-.418a2.48 2.48 0 0 1-1.733-1.768C9.7 22.254 9.7 19 9.7 19s0-3.255.41-4.814a2.48 2.48 0 0 1 1.733-1.768C13.37 12 19.5 12 19.5 12s6.13 0 7.659.418M22.633 19l-5.093-3v6z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "youtube_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.7 12h19.6v14H9.7z"
  })))));
};
export default SvgYoutube;